class EcomMindsSmoothDetails extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('[data-em-smooth-details]');
    this.summary = this.details?.querySelector(':scope > summary');
    this.panel = this.details?.querySelector(':scope > *:not(summary)');

    if (!this.details || !this.summary || !this.panel) return;

    this.duration = 360;
    this.easing = 'cubic-bezier(0.22, 1, 0.36, 1)';
    this.animating = false;

    this.summary.addEventListener('click', this.onClick);

    if (this.details.open) {
      this.panel.style.height = 'auto';
      this.panel.style.opacity = '1';
      this.panel.style.overflow = 'hidden';
    }
  }

  disconnectedCallback() {
    this.summary?.removeEventListener('click', this.onClick);
    this.animation?.cancel();
  }

  onClick = (event) => {
    event.preventDefault();

    if (this.animating) return;

    if (this.details.open) {
      this.close();
    } else {
      this.open();
    }
  };

  open() {
    this.animating = true;
    this.details.open = true;

    this.panel.style.overflow = 'hidden';
    this.panel.style.height = 'auto';

    const targetHeight = this.panel.scrollHeight;

    this.animation?.cancel();
    this.animation = this.panel.animate(
      [
        { height: '0px', opacity: 0, transform: 'translateY(-6px)' },
        { height: `${targetHeight}px`, opacity: 1, transform: 'translateY(0)' },
      ],
      {
        duration: this.prefersReducedMotion ? 0 : this.duration,
        easing: this.easing,
      }
    );

    this.animation.onfinish = () => {
      this.panel.style.height = 'auto';
      this.panel.style.opacity = '1';
      this.panel.style.transform = 'none';
      this.animating = false;
    };

    this.animation.oncancel = () => {
      this.animating = false;
    };
  }

  close() {
    this.animating = true;

    const startHeight = this.panel.getBoundingClientRect().height;
    this.panel.style.overflow = 'hidden';

    this.animation?.cancel();
    this.animation = this.panel.animate(
      [
        { height: `${startHeight}px`, opacity: 1, transform: 'translateY(0)' },
        { height: '0px', opacity: 0, transform: 'translateY(-6px)' },
      ],
      {
        duration: this.prefersReducedMotion ? 0 : this.duration,
        easing: this.easing,
      }
    );

    this.animation.onfinish = () => {
      this.details.open = false;
      this.panel.style.height = '';
      this.panel.style.opacity = '';
      this.panel.style.transform = '';
      this.animating = false;
    };

    this.animation.oncancel = () => {
      this.animating = false;
    };
  }

  get prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
}

if (!customElements.get('ecomminds-smooth-details')) {
  customElements.define('ecomminds-smooth-details', EcomMindsSmoothDetails);
}
